import { ASSET_FORM_TYPE, SPACE_FORM_TYPE } from '../../constants/stringConstants'

// Filter incident type labels based on isPrivate for specific complaint and incident type
// Only applies to complaintId: "NMBS_015" and incidentTypeId: "09.01.01"
// isPrivate: true -> show only labels with isActive: false
// isPrivate: false -> show only labels with isActive: true
function filterIncidentTypeLabelsForNMBS015(incidentTypes, isPrivate) {
    if (!Array.isArray(incidentTypes)) return incidentTypes;

    return incidentTypes.map(incident => {
        // Only apply filtering for incidentTypeId: "09.01.01"
        if (incident.incidentTypeId !== '09.01.01') return incident;
        if (!Array.isArray(incident.incidentTypeLabels)) return incident;

        const filteredLabels = incident.incidentTypeLabels.filter(label => {
            if (isPrivate) {
                return label.isActive === false;
            } else {
                return label.isActive === true;
            }
        });

        return {
            ...incident,
            incidentTypeLabels: filteredLabels
        };
    });
}

// Filter complaints and incidents based on isForEmployeeOnly, isVisitor, isPrivate, and formType
export function filterComplaintsAndIncidentsByEmployeeOnly(assetResponse, isVisitor, isPrivate, formType) {
    const filteredResponse = { ...assetResponse };
    if (!Array.isArray(assetResponse.complaints)) {
        return filteredResponse;
    }

    // Scenario 1: FMS (!isPrivate) - SPACE (SPACE_FORM_TYPE) - No Filtering
    if (!isPrivate && formType === SPACE_FORM_TYPE) {
        filteredResponse.complaints = assetResponse.complaints.map(complaint => {
            // Apply special filtering only for complaintId: "NMBS_015"
            if (complaint.complaintId === 'NMBS_015') {
                return {
                    ...complaint,
                    incidentTypes: filterIncidentTypeLabelsForNMBS015(complaint.incidentTypes, isPrivate)
                };
            }
            return complaint;
        });
        return filteredResponse;
    }

    // For visitors, show all complaints and incidents (no filtering)
    if (isVisitor) {
        filteredResponse.complaints = assetResponse.complaints.map(complaint => {
            // Apply special filtering only for complaintId: "NMBS_015"
            if (complaint.complaintId === 'NMBS_015') {
                return {
                    ...complaint,
                    incidentTypes: filterIncidentTypeLabelsForNMBS015(complaint.incidentTypes, isPrivate)
                };
            }
            return complaint;
        });
        return filteredResponse;
    }

    // For employees, filter out incidents where isForEmployeeOnly is true
    filteredResponse.complaints = assetResponse.complaints
        .map(complaint => {
            if (!Array.isArray(complaint.incidentTypes)) return complaint;
            const filteredIncidents = complaint.incidentTypes.filter(incident => !incident.isForEmployeeOnly);
            if (filteredIncidents.length > 0) {
                // Apply special filtering only for complaintId: "NMBS_015"
                const processedIncidents = complaint.complaintId === 'NMBS_015'
                    ? filterIncidentTypeLabelsForNMBS015(filteredIncidents, isPrivate)
                    : filteredIncidents;
                return { ...complaint, incidentTypes: processedIncidents };
            }
            // If all incidents are filtered out, hide the complaint for employees
            return null;
        })
        .filter(Boolean);
    return filteredResponse;
}